import React, { useState, useEffect } from "react";
import { fetchData } from './api';
import Calendar from './components/Calendar';
import MyCard from './components/Card'; // Assurez-vous que le chemin est correct
import { Box, Container } from '@mui/material';
import Grid from '@mui/material/Grid2';

import "./App.css";


const MyPlanning = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const loadData = async (date) => {
    try {
      const dateString = date.toISOString().split('T')[0]; // YYYY-MM-DD
      const result = await fetchData(`proxy/calendrier/extract/${dateString}`);
      setData(result);
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData(selectedDate);
  }, [selectedDate]);

  if (loading) return <div>Chargement...</div>;
  if (error) return <div>Une erreur est survenue: {error.message}</div>;

  return (
    <Container maxWidth="lg" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <Calendar selectedDate={selectedDate} onDateChange={setSelectedDate} />
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center'}}>
        <Grid container spacing={2} alignItems="stretch" justifyContent="center" sx={{ maxWidth: 'lg' }}>
          {data && data.map(item => (
            <Grid item xs={12} sm={6} md={4} key={item.recordId}>
              <MyCard 
        item={item}
        
             />
            </Grid>
          ))}
        </Grid>
       </Box>
    </Container>
  );
};

export default MyPlanning;
